import { Modal } from 'antd'
import React, { useState } from 'react'
import ReusableTable from '../../other/ReuseableTable'
import EditCreateChannel from './EditCreateChannel'
import Loader from '../../../pages/pages/loader'
import { useGetCustomerChannelsQuery } from '../../../redux/apis/customersManagement/channels/cMChannelsApiSlice'
import { can } from '../../../helpers/auth'

const CustomersChannels = ({ open, setOpen, record }) => {
  const { data, isLoading } = useGetCustomerChannelsQuery({
    expand: ['last_updated_by'].join(','),
    page: '*',
    customer: record?.id
  })

  const [holder, setHolder] = useState()
  const [edit, setEdit] = useState(false)
  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'CHANNEL NAME',
      dataIndex: 'channel_name',
      key: 'channel_name',
      search: true
    },

    {
      title: 'CHANNEL STATUS',
      dataIndex: 'channel_status',
      key: 'channel_status',
      search: true,

      render: text => (text ? 'Active' : 'InActive')
    },
    {
      title: 'VIDEO WM DURATION',
      dataIndex: 'video_wm_duration',
      key: 'video_wm_duration',
      search: true
    },
    {
      title: 'CREATED AT',
      dataIndex: 'created_at',
      key: 'created_at',
      search: true
    },
    {
      title: 'Updated AT',
      dataIndex: 'updated_at',
      key: 'updated_at',
      search: true
    },
    {
      title: 'LAST UPDATED BY',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => (
        <>
          {text.first_name} {text.last_name}
        </>
      )
    },

    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'actions',
      render: (text, channel) => (
        <div className='flex gap-2'>
          {can('change_customerchannel') && (
            <button
              className='btn btn-outline-theme'
              onClick={() => handleEdit(channel)}
            >
              Edit
            </button>
          )}
        </div>
      )
    }
  ]

  const handleEdit = channel => {
    setHolder(channel)
    setEdit(true)
  }
  return (
    <Modal
      className='custom-modal'
      open={open}
      title={`${record.customer_name} Channels`}
      onCancel={() => setOpen(false)}
      width={'60%'}
      footer={false}
    >
      <div className='w-full flex flex-col'>
        <Loader isLoading={isLoading} />
        {create ? (
          <EditCreateChannel
            state={'create'}
            open={create}
            setOpen={setCreate}
            record={null}
            customerId={record?.id}
          />
        ) : null}
        {edit ? (
          <EditCreateChannel
            state={'edit'}
            open={edit}
            setOpen={setEdit}
            record={holder}
            customerId={record?.id}
          />
        ) : null}
        <button
          className='btn btn-outline-theme ml-auto'
          onClick={() => setCreate(true)}
        >
          Create Channel
        </button>
        <br />
        <div className='row'>
          <ReusableTable columns={columns} data={data?.data?.results} />
        </div>
      </div>
    </Modal>
  )
}

export default CustomersChannels
